// extracted by mini-css-extract-plugin
export default {"explain":"styles_explain__eX5E0","explain__icon":"styles_explain__icon__Y6eXD","explain__tooltip":"styles_explain__tooltip__nz9hj","spin":"styles_spin__wWCgf"};